import { gql } from 'react-apollo';

export const savePreference = gql`
  mutation savePreference(
    $userId: String!
    $preference: PreferenceName!
    $value: JSONString!
    $context: Context
    $contextId: String
  ) {
    savePreference(
      userId: $userId
      preference: $preference
      value: $value
      context: $context
      contextId: $contextId
    ) {
      ok
    }
  }
`;
